import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { INSTAGRAM } from "@/data/content";

const SHOTS = [
  { src: "/assets/fjarrvarme-4.webp", alt: "Fjärrvärmecentral monterad i Huddinge – Uusimaa Svets & VVS AB" },
  { src: "/assets/fredrik-welding.webp", alt: "Svetsning med gnistor – Uusimaa Svets & VVS AB" },
  { src: "/assets/fjarrvarme-2.webp", alt: "Fjärrvärmecentral i tekniskt rum i Haninge – Uusimaa Svets & VVS AB" },
  { src: "/assets/fredrik-working.webp", alt: "Montage av rörinstallation – Uusimaa Svets & VVS AB" },
];

export default function InstagramStrip() {
  return (
    <section data-testid="instagram-section" className="border-b border-white/10 py-20 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 flex flex-col gap-6 sm:mb-16 sm:flex-row sm:items-end sm:justify-between"
        >
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-neutral-500">06 / Instagram</p>
            <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-5xl">
              Följ oss <span className="text-neutral-500">i arbetet</span>
            </h2>
          </div>
          <a
            data-testid="instagram-follow-button"
            href={INSTAGRAM.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex w-fit items-center gap-2 border border-white/25 px-6 py-3.5 font-mono text-xs uppercase tracking-[0.18em] text-white transition-colors duration-200 hover:border-white/70"
          >
            <Instagram className="h-4 w-4" />
            {INSTAGRAM.handle}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {SHOTS.map((shot, i) => (
            <motion.a
              key={shot.src}
              data-testid={`instagram-link-${i + 1}`}
              href={INSTAGRAM.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="group relative block overflow-hidden border border-white/10 transition-colors duration-300 hover:border-white/30"
              aria-label={`Öppna Uusimaa Svets & VVS AB på Instagram – ${shot.alt}`}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={shot.src}
                  alt={shot.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                />
              </div>
              <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors duration-300 group-hover:bg-black/45">
                <Instagram className="h-7 w-7 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
